<style lang="less" scoped>
  .container {
    width: 100%;
    max-width: 960px;
    padding: 0 16px;
    margin: auto;
    display: flex;
}

  .description {
    width: 100%;
    border-radius: 4px;
    background: #f8f8f8;
    padding: 12px 16px;
    margin-bottom: 24px;
  }

  .area-container-mobile {
    padding-bottom: 90px;
  }

  .order-page-content {
    .order-form-desktop {
      display: flex;
    }
    .buy-info-cover {
      flex: 1;
    }
  }
  .prescriptions-list {
    padding-right: 32px;
  }
  .mobile-order-result-cover {
    display: flex;
    width: 100%;

    .mobile-order-info {
      flex: 1;
    }
  }

  .order-add-square {
    border: 1px dotted #8492a6;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 126px;
    font-weight: bold;
    text-align: center;
    color: #8492a6;
    font-size: 17px;
    border-radius: 4px;
    > img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }

  @media screen and (max-width: 560px) {
    .order-page-content {
      .order-form-desktop {
        flex-direction: column;
      }
      .buy-info-area {
        box-shadow: none;
      }
      .mobile-hide {
        display: none;
      }
    }
    .prescriptions-list {
      padding-right: 0;
    }
  }
</style>

<template lang="pug">
  #orders
    .area-container.area-container-mobile
      // 처방명 입력 다이얼로그
      el-dialog.add-recipe-dialog.custom-dialog(
        title="처방명 입력",
        :visible.sync="dialogStatus.isOpenAddRecipeDialog")
        recipe-name-input-modal(@addPrescription="addPrescription($event)")
      // 처방 선택 다이얼로그
      el-dialog.add-recipe-type-dialog.custom-dialog(
        title="처방 검색",
        :visible.sync="dialogStatus.isOpenAddMedicineDialog")
        form(action='#' method='post')
          recipe-choose-modal(
            :prescriptions="dialogPrescriptions",
            @selectPrescription="selectPrescription($event)",
            @search="bindDialogPrescriptions($event)",
            v-if="dialogStatus.isOpenAddMedicineDialog")
      // 약재 선택 다이얼로그
      el-dialog.add-medicine-dialog.custom-dialog(
        title="약재 선택",
        :visible.sync="dialogStatus.isOpenAddPartsDialog",)
        form(action='#' method='post')
          present-choose-modal(
            :ingredients="dialogIngredients",
            @selectIngredient="addIngredient($event)",
            @search="bindDialogIngredients($event)",
            v-if="dialogStatus.isOpenAddPartsDialog")
      // 처방 타입 선택 다이얼로그
      el-dialog.add-recipe-type-dialog.custom-dialog.none-title-dialog(
        title="처방 추가",
        :visible.sync="dialogStatus.isOpenSelectTypeDialog")
        form(action='#' method='post')
          recipe-add-modal(
            @closeDialog="openDialog()",
            @openDialog="openDialog($event)")
      .order-content
        div
          .page-title-area
            h1 {{title}}
            .nav-area
              router-link(to="#")
                // el-button.order-cancel-btn 주문취소
          .order-page-content.page-container
            form.order-form-desktop(
              action="#",
              method="get",
              @submit.prevent="submit")
              .col.prescriptions-list(
                :class="{ 'mobile-hide' : process !== 1 }")
                .description 아래 처방 추가 버튼을 눌러 기본 처방을 가져오거나 새 처방을 직접 추가하세요.
                .order-cover
                  present-form-component(
                    v-for="prescription in orders.prescriptions",
                    :prescription="prescription",
                    :delivery="orders.delivery"
                    @openDialog="openDialog($event)",
                    @selectIngredientList="selectIngredientList",
                    @remove="removePrescription(prescription)")
                // 처방명 입력 다이얼로그 오픈 버튼
                .order-add-square(@click="openDialog(4)")
                  img(src="@/assets/add-circle-gray@2x.png")
                  span 처방 추가
              .col.buy-info-cover(
                :class="{ 'mobile-hide' : process !== 2 }")
                sender-form-component(:orders="orders" :totalPrice="totalPrice")
        .mobile.mobile-bottom-ui-cover
          .mobile-order-result-cover
            .mobile-order-info
              strong 총 {{totalPrice.toLocaleString()}}원
              div
                span {{orderName}}
            .mobile.mobile-order-btn-cover
              el-button(type="success" @click="mobileSubmit") 주문하기
</template>

<script>
import presentFormComponent from '@/components/present_form';
import senderFormComponent from '@/components/sender_form';

// Modal 내용 컴포넌트
import recipeNameInputModal from '@/components/modal/modal_recipe_name_input';
import recipeChooseModal from '@/components/modal/modal_recipe_choose';
import presentChooseModal from '@/components/modal/modal_present_choose';
import recipeAddModal from '@/components/modal/modal_recipe_add';
import { mapState } from 'vuex';
import happytree from '@/happytree';

export default {
  props: {
    title: {
      type: String,
    },
  },
  computed: {
    ...mapState({
      me: state => state.app.me,
    }),
    firstPrescriptionName() {
      const name = this.orders.prescriptions.length > 0 ? this.orders.prescriptions[0].name : null;
      return name;
    },
    otherCount() {
      const count = this.orders.prescriptions.length - 1;
      return count > 0 ? count : false;
    },
    orderName() {
      let result = this.firstPrescriptionName;
      if (this.otherCount) {
        result = result.concat(` 외 ${this.otherCount}건`);
      }
      return result;
    },
    totalPrice() {
      let result = 0;
      this.orders.prescriptions.forEach((prescription) => {
        const totalprice = prescription.totalprice;
        result += totalprice;
      });
      const packs = this.orders.prescriptions.reduce((p, c) => p + c.packs, 0);

      let deliveryPrice = 4000;
      switch (this.orders.delivery) {
        case happytree.delivery.basic:
          deliveryPrice = 4000;
          break;
        case happytree.delivery.oneday:
          deliveryPrice = 5000;
          break;

        default: break;
      }
      result += (Math.floor(packs / 45) + ((packs % 45) > 0 ? 1 : 0)) * deliveryPrice; // 45팩당 배달비 추가
      return result;
    },
  },
  methods: {
    openDialog(dialog) {
      Object.keys(this.dialogStatus).forEach((key) => {
        this.dialogStatus[key] = false;
      });
      switch (dialog) {
        case 1:
          this.dialogStatus.isOpenAddRecipeDialog = true;
          break;

        case 2:
          this.dialogStatus.isOpenAddMedicineDialog = true;
          break;

        case 3:
          this.dialogStatus.isOpenAddPartsDialog = true;
          break;

        case 4:
          this.dialogStatus.isOpenSelectTypeDialog = true;
          break;

        default:
      }
    },
    addIngredient(obj) {
      const already = this.selectIngredients.findIndex(element => element.ingredient === obj._id);
      if (already !== -1) {
        alert('이미 해당 약재가 처방 내에 존재합니다.');
        return false;
      }
      // 약재 추가
      const result = {
        ingredient: obj._id,
        amount: 1,
      };
      this.selectIngredients.push(result);
      this.openDialog(); // 선택 후 다이얼로그 닫는 용도
      return true;
    },
    selectPrescription(obj) {
      // 처방 추가
      obj.totalprice = 0;
      this.orders.prescriptions.push(obj);
      this.openDialog(); // 선택 후 다이얼로그 닫는 용도
    },
    addPrescription(name) {
      const obj = {
        name: name,
        ingredients: [],
        units: 1,
        packs: 1,
        totalprice: 0,
      };
      this.orders.prescriptions.push(obj);
      this.openDialog(); // 입력 후 다이얼로그 닫는 용도
    },
    removePrescription(obj) {
      const index = this.orders.prescriptions.findIndex(prescription => prescription === obj);
      if (index !== -1) {
        this.orders.prescriptions.splice(index, 1);
      }
    },
    replacePhoneNumber(phoneNumber) {
      const regex = new RegExp(/^(\d{3})(\d{3,4})(\d{4})$/);
      if (phoneNumber === null) {
        return false;
      }
      if (phoneNumber.match(regex) === false) {
        return false;
      }
      const editedPhoneNumber = phoneNumber.split(regex).filter(val => val).join('-');
      return editedPhoneNumber;
    },
    async submit() {
      let msg = null;
      const phoneNumber = this.replacePhoneNumber(this.orders.phoneNumber);

      /* 여기부터 주문 안되는 상황들 추가 */
      // 입력되지 않은 값이 있을 경우 예외처리
      const payload = {
        prescriptions: this.orders.prescriptions,
        name: this.orders.name,
        phoneNumber: phoneNumber,
        address: this.orders.address,
        delivery: this.orders.delivery,
        receipt: 'url',
        paymentMethod: this.orders.paymentMethod,
      };

      Object.keys(payload).forEach((key) => {
        const check = payload[key];
        let result = true;
        if (!check) {
          result = false;
        }
        if (phoneNumber === false) {
          msg = '휴대폰 번호가 입력되지 않았거나, 양식에 맞지 않습니다.';
        }
        if (result === false) {
          msg = '입력되지 않은 값이 존재합니다.';
        }
      });
      // 약재의 재고가 없거나, 약재 갯수가 0 이하의 값이 입력되었을 경우 주문 방지
      payload.prescriptions.forEach((prescription) => {
        if (prescription.ingredients.length <= 0) {
          msg = '약재가 등록되지 않은 처방이 존재합니다.';
        }
        if (prescription.units <= 0 || prescription.packs <= 0) {
          msg = '첩수나 팩수가 잘못 입력 된 처방이 존재합니다.';
        }
        prescription.ingredients.forEach((ingredient) => {
          if (ingredient.amount <= 0) {
            msg = '약재의 재고와 용량을 확인해주세요.';
          }
        });
      });
      if (msg !== null) {
        alert(msg);
        return false;
      }
      /* 주문 예외처리 끝 */
      const orderData = await this.$http.post('/orders', payload);
      const IMP = window.IMP;
      const giftName = `[${payload.name}] ${this.orderName}`;
      IMP.init('imp71066827');
      const impPayload = {
        pg: 'inicis',
        pay_method: this.orders.paymentMethod,
        merchant_uid: orderData.data._id,
        // name: payload.name,
        name: giftName,
        amount: orderData.data.totalPrice,
        buyer_email: this.me.email,
        buyer_name: this.me.name,
        buyer_tel: payload.phoneNumber,
        buyer_addr: payload.address,
        buyer_postcode: '01181',
      };
      IMP.request_pay(impPayload, (res) => {
        if (res.success) {
          // 결제 성공
          this.$router.replace('/complete/'.concat(orderData.data._id));
        } else {
          // 결제 실패
          alert('주문에 실패하였습니다.');
        }
      });
      return true;
    },
    async mobileSubmit() {
      if (this.process === 1) {
        this.process = 2;
      } else if (this.process === 2) {
        await this.submit();
      }
    },
    selectIngredientList(obj) {
      this.selectIngredients = obj;
    },
    async loadPrescriptionsData(keyword) {
      let destination = '/prescriptions';
      if (keyword) {
        destination = destination.concat('?q='.concat(keyword));
      }
      const { data } = await this.$http.get(destination);
      return data;
    },
    async loadIngredientsData(keyword) {
      let destination = '/ingredients';
      if (keyword) {
        destination = destination.concat('?q='.concat(keyword));
      }
      const { data } = await this.$http.get(destination);
      return data;
    },
    async bindDialogPrescriptions(keyword) {
      this.dialogPrescriptions = await this.loadPrescriptionsData(keyword);
    },
    async bindDialogIngredients(keyword) {
      this.dialogIngredients = await this.loadIngredientsData(keyword);
    },
  },
  data() {
    return {
      process: 1, // 현재 작업 진행도 (모바일에서 사용)
      selectIngredients: null, // 약재를 추가할 처방의 배열
      page: {
        title: '새로운 주문',
        previous: false,
      },
      dialogStatus: {
        isOpenAddRecipeDialog: false,
        isOpenAddMedicineDialog: false,
        isOpenAddPartsDialog: false,
        isOpenSelectTypeDialog: false,
      },
      dialogPrescriptions: [],
      dialogIngredients: [],
      // 여기부터 주문에 관련된 데이터들임
      orders: {
        prescriptions: [], // 처방을 불러오면 처방의 데이터가 이 곳에 들어감.
        name: null, // 사람 이름
        phoneNumber: null, // 전화번호
        address: null, // 주소
        delivery: 'basic', // 배송 방법
        invoiceNumber: null, // 송장 번호
        receipt: null, // 영수증
        paymentMethod: null,
        totalprice: 0, // 최종 가격
      },
    };
  },
  components: {
    presentFormComponent,
    senderFormComponent,
    recipeNameInputModal,
    recipeChooseModal,
    recipeAddModal,
    presentChooseModal,
  },
  async mounted() {
    this.$store.commit('setTitle', this.title);
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/orders.vue